module.exports = "<footer id=\"footer\" style=\"background-color:transparent;padding-bottom:50px\">\r\n    <div class=\"hide-fixed\" style=\"position: relative;top: -7px;\">\r\n        <span>   Powered by </span>\r\n        <img src=\"../.../../Content/images/medinous_foot.png\" />\r\n    </div>\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./app/shared/footer/footer.template.html
// module id = 602
// module chunks = 3